export const networksImg = {
    eth: "https://www.paymentscardsandmobile.com/wp-content/uploads/2017/09/ETHEREUM-ICON_Black-300x300.png"
}

export const walletNetworkVerification = (str:string) : string => {
    let network = '';
    if (str) {
        if (str[0].toLowerCase().includes("t")) network = "Tron-chain"
        if (str[0].toLowerCase().includes("0")) {
            if (str[1] && str[1].toLowerCase().includes("x")) network = "Ethereum-chain"
        }
    }
    return network;
}